import { render, staticRenderFns } from "./DefaultContainerScroll.vue?vue&type=template&id=17ecfc80&scoped=true&"
var script = {}
import style0 from "./DefaultContainerScroll.vue?vue&type=style&index=0&id=17ecfc80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecfc80",
  null
  
)

export default component.exports